import * as R from "ramda";
import { DATAQUERY_VALUES_SEPARATOR, DATAQUERY_DIMENSIONS_SEPARATOR } from "./constants/url.mjs";
const getDataquery = (dimensions, selections) => R.pipe(
  R.map(
    (dim) => R.pipe(
      R.propOr([], "values"),
      R.indexBy(R.prop("id")),
      R.pick(R.propOr([], R.prop("id", dim), selections)),
      R.values,
      R.map(R.prop("id")),
      R.join(DATAQUERY_VALUES_SEPARATOR)
    )(dim)
  ),
  R.join(DATAQUERY_DIMENSIONS_SEPARATOR)
)(dimensions);
const getDataquery$1 = R.curry(getDataquery);
export {
  getDataquery$1 as default
};
